import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function Requirements() {
  const { ref, isVisible } = useScrollReveal();

  const platformCards = [
    {
      image:
        "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/b-windows.png",
      alt: "Windows",
    },
    {
      image:
        "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/b-bing.png",
      alt: "Bing",
    },
    {
      image:
        "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/b-edge.png",
      alt: "Edge",
    },
    {
      image:
        "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/b-msn.png",
      alt: "MSN",
    },
    {
      image:
        "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/b-copilot.png",
      alt: "Copilot",
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-[#3b82f6] py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16 relative overflow-hidden`}
    >
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-20 z-0"
      >
        <source
          src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/WEBPAGE-nocard-1080p.mp4"
          type="video/mp4"
        />
      </video>

      {/* Content Overlay */}
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="flex flex-col items-center gap-8 mb-12">
            {/* Badge */}
            <div className="bg-white border border-[#dadada] rounded-[100px] px-5 py-3">
              <p className="text-[#3b82f6] text-[18px] xxs:text-[14px] xs:text-[15px] sm:text-[15px] md:text-[18px] lg:text-[16px] xl:text-[16px] 4xl:text-[24px] font-medium enfinity-subtext-font">
                Content Requirements
              </p>
            </div>

            {/* Main Heading */}
            <h1
              className="text-4xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal text-white text-center leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal max-w-[1085px] enfinity-header-font"
              style={{ lineHeight: "1.2" }}
            >
              Your Videos Everywhere People Look
            </h1>

            {/* Subtitle */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-white text-center leading-[34px] enfinity-subtext-font">
              From the moment someone turns on their computer to searching the
              web, your content is there.
            </p>
          </div>

          {/* Mobile Image Section */}
          <div className="flex justify-center mb-12 lg:hidden">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/content.png"
              alt="Boost 5 Cards"
              className="w-full h-auto object-contain max-w-full"
            />
          </div>

          {/* Platform Cards Section */}
          <div className="hidden lg:flex flex-nowrap justify-center gap-[29px] mb-12 overflow-x-auto">
            {platformCards.map((card, index) => (
              <div
                key={index}
                className="bg-white rounded-[20px] w-[200px] h-[400px] lg:w-[160px] lg:h-[280px] xl:w-[200px] xl:h-[350px] 1xl:w-[230px] 1xl:h-[410px] 2xl:w-[230px] 2xl:h-[400px] flex-shrink-0 overflow-hidden flex items-center justify-center"
              >
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-contain"
                />
              </div>
            ))}
          </div>

          {/* Stats Section */}
          <div className="bg-white rounded-[20px] px-[60px] py-4 flex flex-col md:flex-row items-center justify-between gap-6 max-w-[807px] mx-auto">
            {/* Stat 1 */}
            <div className="flex flex-col gap-[5px] items-center">
              <p className="text-[#3b82f6] text-[62px]  font-semibold enfinity-header-font">
                2B+
              </p>
              <p className="text-[18px] xxs:text-[14px] xs:text-[18px] sm:text-[18px] md:text-[15px] lg:text-[17px] 4xl:text-[20px] font-normal text-black enfinity-subtext-font">
                Total People Reached
              </p>
            </div>

            {/* Divider */}
            <div className="h-[70px] w-px bg-[#dadada] hidden md:block" />

            {/* Stat 2 */}
            <div className="flex flex-col gap-[5px] items-center">
              <p className="text-[#3b82f6] text-[62px] font-semibold enfinity-header-font">
                180+
              </p>
              <p className="text-[18px] xxs:text-[14px] xs:text-[18px] sm:text-[18px] md:text-[15px] lg:text-[17px] 4xl:text-[20px] font-normal text-black enfinity-subtext-font">
                Countries Worldwide
              </p>
            </div>

            {/* Divider */}
            <div className="h-[70px] w-px bg-[#dadada] hidden md:block" />

            {/* Stat 3 */}
            <div className="flex flex-col gap-[5px] items-center">
              <p className="text-[#3b82f6] text-[62px] font-semibold enfinity-header-font">
                24/7
              </p>
              <p className="text-[18px] xxs:text-[14px] xs:text-[18px] sm:text-[18px] md:text-[15px] lg:text-[17px] 4xl:text-[20px] font-normal text-black enfinity-subtext-font">
                Always Visible
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
